<div class="dtf-olp" style="background-color: #E6E6E6;">
    <div class="container_dashboard" >
        <div class="dtf-dashboard" style="padding-top: 41px; padding-bottom: 0px;">
            <div class="example-button-row">
                <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="selectedState"
                    (change)="onChangeButton($event)">
                    <mat-button-toggle [value]="toggleEnum.Option7"
                        [class.selected]="selectedState === toggleEnum.Option7">Make a Payment</mat-button-toggle>
                    <mat-button-toggle [value]="toggleEnum.Option1"
                        [class.selected]="selectedState === toggleEnum.Option1">Principal Payment</mat-button-toggle>
                    <mat-button-toggle [value]="toggleEnum.Option3"
                        [class.selected]="selectedState === toggleEnum.Option3">Statement Payment</mat-button-toggle>
                    <mat-button-toggle [value]="toggleEnum.Option6"
                        [class.selected]="selectedState === toggleEnum.Option6">Recurring Payment</mat-button-toggle>
                    <mat-button-toggle [value]="toggleEnum.Option4"
                        [class.selected]="selectedState === toggleEnum.Option4">Manage Bank Profile</mat-button-toggle>
                    <mat-button-toggle [value]="toggleEnum.Option2"
                        [class.selected]="selectedState === toggleEnum.Option2">Payment History</mat-button-toggle>
                    <mat-button-toggle [value]="toggleEnum.Option8"
                        [class.selected]="selectedState === toggleEnum.Option8">Help</mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </div>
    </div>

    <div class="container_dashboard" >
        <div style="padding-bottom: 21px;">
            <h1 style="margin-left: 2%;">Scheduled Payments</h1>

            <div class="container_dashboard" style=" padding-top: 0px;">
                <br>
                <div *ngIf="scheduledpayment">
                    <div class="card" style="margin-left: 20px; width: 98%;">
                        <p style="margin-bottom: 0px;">Search By: </p>
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-2 col-6">
                                <p class="filter" style="font-weight: bold; font-size: 15px;">{{
                                    'recurringpayment.filter1' |
                                    translate }}</p>
                                <div class="row">
                                    <div class="col">
                                        <mat-form-field appearance="outline" style="width: 100%;">
                                            <mat-label>{{ 'recurringpayment.filter1label' | translate }}</mat-label>
                                            <input matInput style="outline: none;" #input
                                                (keyup)="applyFilterAcc($event.target.value)" type="text">
                                            <img matSuffix class="example-form-img"
                                                src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-2 col-6">
                                <p class="filter" style="font-weight: bold; font-size: 15px;">{{
                                    'recurringpayment.filter2' |
                                    translate
                                    }}</p>
                                <div class="row">
                                    <div class="col">
                                        <mat-form-field appearance="outline" style=" width: 100%; height: 55px;">
                                            <mat-label>Status</mat-label>
                                            <mat-select (selectionChange)="applyStatusFilter($event.value)">
                                                @for (status of statuses; track status) {
                                                <mat-option [value]="status.value">{{status.viewValue}}</mat-option>
                                                }
                                            </mat-select>
                                            <img matSuffix class="example-form-img"
                                                src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-5 col-6">
                                <p class="filter" style="font-weight: bold; font-size: 15px;">{{
                                    'recurringpayment.filter3' |
                                    translate
                                    }} </p>
                                <div class="row">
                                    <div class="col">
                                        <mat-form-field appearance="outline" style="width: 100%;">
                                            <mat-label>{{ 'recurringpayment.filter3label' | translate }}</mat-label>

                                            <mat-date-range-input [rangePicker]="picker"
                                                [(ngModel)]="selectedDateRange">
                                                <input matStartDate placeholder="Start date"
                                                    (dateChange)="onDateRangeChange($event)">
                                                <input matEndDate placeholder="End date"
                                                    (dateChange)="onDateRangeChange($event)">
                                            </mat-date-range-input>

                                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-date-range-picker #picker></mat-date-range-picker>

                                            <img matSuffix class="example-form-img"
                                                style="display: inline-block; margin-top: -15px;"
                                                src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
                                        </mat-form-field>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>

                    <!-- Recurring Payment Table  -->

                    <div class="card">

                        <h5 style="font-weight: bold;">{{ 'recurringpayment.tableheader1' | translate }}</h5>

                        <p>Edit, or Terminate your existing scheduled payments to ensure your preferences are always up
                            to date.
                        </p>

                        <div *ngIf="showerror" style="color: red;">
                            Please select one subscription to terminate.
                        </div>

                        <mat-table [dataSource]="HistoricalSubscriptionDataSource" multiTemplateDataRows
                            class="mat-elevation-z8" matSort>
                            <!--US/EN Table loading-->
                            <ng-container matColumnDef="{{column.name}}"
                                *ngFor="let column of initColumns; last as isLast; first as isFirst;">
                                <mat-header-cell mat-sort-header *matHeaderCellDef>
                                    <div> {{column.display}}</div>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <span class="mobile-label">
                                        <div> {{column.display}} :</div>
                                    </span>
                                    <div *ngIf="column.dispFormat=='select'">
                                        <div style="padding-left: 24px;">
                                            <mat-checkbox (click)="$event.stopPropagation();"
                                                (change)="$event ? selectionHis.toggle(element) : null"
                                                [checked]="selectionHis.isSelected(element)">
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                    <div *ngIf="column.dispFormat=='paymentamount'">
                                        <!--Formats Contract String Columns-->
                                        {{ ( element.calculated_amounts.gross_order_total / 100 ) |
                                        currency:'USD':true:'1.2-2'}}
                                    </div>
                                    <div *ngIf="column.dispFormat=='acct'"> <!--Formats String Columns-->
                                        {{element.line_items[0].description}}
                                    </div>
                                    <div *ngIf="column.dispFormat=='date1'"> <!--Formats date Columns-->
                                        {{element.execution_interval.start_date | date:'MM/dd/yyyy'}}
                                    </div>
                                    <div *ngIf="column.dispFormat=='date2'"> <!--Formats date Columns-->
                                        {{element.execution_interval.end_date | date:'MM/dd/yyyy'}}
                                    </div>
                                    <div *ngIf="column.dispFormat=='transaction'"> <!--Formats String Columns-->
                                        {{element.reference}}
                                    </div>
                                    <div *ngIf="column.dispFormat=='status'"> <!--Formats String Columns-->
                                        {{element.status}}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                            <ng-container matColumnDef="subscriptionList">
                                <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                                    [attr.colspan]="displayedColumns.length">
                                </mat-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
                                [class.example-expanded-row]="subscriptionList === element"
                                (click)="subscriptionList = subscriptionList === element ? null : element">
                            </mat-row>
                            <mat-row *matRowDef="let row; columns: ['subscriptionList']"
                                class="example-detail-row"></mat-row>

                            <!-- Row shown when there is no matching data. -->
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter </td>
                                <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                                </td>
                            </tr>

                        </mat-table>
                        <mat-paginator [pageSizeOptions]="[5,10, 25, 100]"></mat-paginator>

                        <br>
                        <div style="display:flex;flex-direction: row;gap:10px">
                            <div *ngIf="agentview ==='true'">
                                <button class="mbfs-button" disabled>TERMINATE</button>
                            </div>
                            <div *ngIf="agentview !='true'">
                                <button class="mbfs-button" [disabled]="isTerminateDisabled()" (click)="Remove()">TERMINATE</button>
                            </div>
                        </div>

                    </div>
                </div>

                <div *ngIf="CancelSubscriptionSuccess">

                    <div class="card">
                        <p>The subscription is cancelled.</p>

                        <mat-table [dataSource]="CancelSubscriptionDataSource" multiTemplateDataRows
                            class="mat-elevation-z8" matSort>
                            <!--US/EN Table loading-->
                            <ng-container matColumnDef="{{column.name}}"
                                *ngFor="let column of CancelSubinitColumns; last as isLast; first as isFirst;">
                                <mat-header-cell mat-sort-header *matHeaderCellDef>
                                    <div> {{column.display}}</div>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <span class="mobile-label">
                                        <div> {{column.display}} :</div>
                                    </span>
                                    <div *ngIf="column.dispFormat=='acct'"> <!--Formats String Columns-->
                                        {{element.line_items[0].description}}
                                    </div>
                                    <div *ngIf="column.dispFormat=='paymentamount'"> <!--Formats String Columns-->
                                        {{ (element.calculated_amounts.gross_order_total / 100) |
                                        currency:'USD':true:'1.2-2'}}
                                    </div>
                                    <div *ngIf="column.dispFormat=='date1'"> <!--Formats String Columns-->
                                        {{element.execution_interval.start_date | date:'MM/dd/yyyy'}}
                                    </div>
                                    <div *ngIf="column.dispFormat=='date2'"> <!--Formats String Columns-->
                                        {{element.execution_interval.end_date | date:'MM/dd/yyyy'}}
                                    </div>
                                    <div *ngIf="column.dispFormat=='transaction'" style="color: red;">
                                        <!--Formats String Columns-->
                                        {{element.reference}}
                                    </div>
                                    <div *ngIf="column.dispFormat=='status'" style="color: red;">
                                        <!--Formats String Columns-->
                                        {{element.status}}
                                    </div>
                                </mat-cell>
                            </ng-container>
                            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                            <ng-container matColumnDef="CancelSubscriptionData">
                                <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                                    [attr.colspan]="displayedColumnsCancelSub.length">
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumnsCancelSub"></mat-header-row>
                            <mat-row *matRowDef="let element; columns: displayedColumnsCancelSub;"
                                class="example-element-row"
                                [class.example-expanded-row]="CancelSubscriptionData === element"
                                (click)="CancelSubscriptionData = CancelSubscriptionData === element ? null : element">
                            </mat-row>
                            <mat-row *matRowDef="let row; columns: ['CancelSubscriptionData']"
                                class="example-detail-row"></mat-row>
                            <!-- Row shown when there is no matching data. -->
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter </td>
                                <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                                </td>
                            </tr>
                        </mat-table>
                        <br>
                    </div>
                    <button class="mbfs-button" (click)="CancelledSubscription()">DONE</button>
                </div>

                <br><br>
            </div>
        </div>
    </div>